import Effect from '@/roc/effects/Effect';
import EffectMechanic from '@/roc/effects/EffectMechanic';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
class PassiveAura extends Effect {
    __type;
    __amount;
    __unit;
    constructor(type, amount, unit = '') {
        super(EffectMechanic.PASSIVE_AURA);
        this.__type = type;
        this.__amount = amount;
        this.__unit = unit;
    }
    get type() {
        return this.__type;
    }
    getAmount(level, era) {
        let amount = this.__amount.calculate(level, era);
        if (!amount) {
            return null;
        }
        for (let i = 0; i < this.__mods.length; i++) {
            const mod = this.__mods[i];
            amount = mod.apply(amount);
        }
        switch (this.__type) {
            case PassiveAuraType.LIGHT_INFANTRY_CRITICAL_HIT_CHANCE_MOD:
                amount = amount / 100 * 4;
                break;
            case PassiveAuraType.RANGED_CRITICAL_HIT_CHANCE_MOD:
                amount = amount / 100 * 5;
                break;
            case PassiveAuraType.HEAVY_INFANTRY_CRITICAL_HIT_CHANCE_MOD:
                amount = amount / 100 * 10;
                break;
        }
        return amount;
    }
    clone(type = null, amount = null, unit = null) {
        return new PassiveAura(type || this.__type, amount || this.__amount, unit || this.__unit);
    }
    formatDescription(level, era) {
        let amount = this.getAmount(level, era);
        if (!amount) {
            return '';
        }
        let unit = this.__unit;
        if (this.__unit === 's') {
            amount /= 60;
            const m = amount % 60;
            const h = (amount - m) / 60;
            if (m > 0) {
                amount = (h > 0 ? h + 'h ' : '') + m + 'm';
            }
            else if (h === 24) {
                amount = '1d';
            }
            else {
                amount = h + 'h';
            }
            unit = '';
        }
        else {
            if (amount.toFixed(2).endsWith('.00') || amount.toFixed(1).endsWith('.0')) {
                amount = amount.toFixed(0);
            }
        }
        switch (this.__type) {
            case PassiveAuraType.INFANTRY_BARRACKS_RECRUITMENT_TIME_BONUS:
                return 'Reduce light infantry barracks recruitment time by ' + amount + unit;
            case PassiveAuraType.SIEGE_BARRACKS_RECRUITMENT_TIME_BONUS:
                return 'Reduce siege barracks recruitment time by ' + amount + unit;
            case PassiveAuraType.ALL_BARRACKS_RECRUITMENT_TIME_BONUS:
                return 'Reduce recruitment time for all barracks by ' + amount + unit;
            case PassiveAuraType.AZTEC_TEMPLE_RECRUITMENT_TIME_BONUS:
                return 'Reduce Aztec Temple recruitment time to ' + amount;
            case PassiveAuraType.RANGED_BARRACKS_RECRUITMENT_TIME_BONUS:
                return 'Reduce ranged barracks recruitment time by ' + amount + unit;
            case PassiveAuraType.TREASURE_HUNT_ATTEMPT_GENERATION_TIME_BONUS:
                return 'Reduce Treasure Hunt attempt generation time by ' + amount + unit;
            case PassiveAuraType.IMPERIAL_GUARD_PRODUCTION_TIME_BONUS:
                return 'Reduce imperial guard recruitment time by ' + amount + unit;
            case PassiveAuraType.MAYA_ARCHERS_PRODUCTION_TIME_BONUS:
                return 'Reduce maya archer recruitment time by ' + amount + unit;
            case PassiveAuraType.CARCASSONNE_SENTINELS_PRODUCTION_TIME_BONUS:
                return 'Reduce carcassonne sentinel recruitment time by ' + amount + unit;
            case PassiveAuraType.HEAVY_INFANTRY_PRODUCTION_TIME_BONUS:
                return 'Reduce heavy infantry barracks recruitment time by ' + amount + unit;
            case PassiveAuraType.RESEARCH_POINT_GENERATION_TIME_BONUS:
                return 'Reduce research point generation time by ' + amount + unit;
            case PassiveAuraType.DOCK_WORKER_TIME_BONUS:
                return 'Reduce trade offer cooldown time by ' + amount + unit;
            case PassiveAuraType.HEAVY_INFANTRY_HIT_POINT_MOD:
                return 'Increase heavy infantry hit points by ' + amount + unit;
            case PassiveAuraType.LIGHT_INFANTRY_HIT_POINT_MOD:
                return 'Increase light infantry hit points by ' + amount + unit;
            case PassiveAuraType.RANGED_HIT_POINT_MOD:
                return 'Increase ranged hit points by ' + amount + unit;
            case PassiveAuraType.CAVALRY_HIT_POINT_MOD:
                return 'Increase cavalry hit points by ' + amount + unit;
            case PassiveAuraType.SIEGE_HIT_POINT_MOD:
                return 'Increase siege hit points by ' + amount + unit;
            case PassiveAuraType.BASTION_HIT_POINT_MOD:
                return 'Increase bastion hit points by ' + amount + unit;
            case PassiveAuraType.TOTAL_HIT_POINT_MOD:
                return 'Increase hit points of all units by ' + amount + unit;
            case PassiveAuraType.RANGED_DAMAGE_MOD:
                return 'Increase ranged damage by ' + amount + unit;
            case PassiveAuraType.LIGHT_INFANTRY_DAMAGE_MOD:
                return 'Increase infantry damage by ' + amount + unit;
            case PassiveAuraType.HEAVY_INFANTRY_DAMAGE_MOD:
                return 'Increase heavy infantry damage by ' + amount + unit;
            case PassiveAuraType.CAVALRY_DAMAGE_MOD:
                return 'Increase cavalry damage by ' + amount + unit;
            case PassiveAuraType.SIEGE_DAMAGE_MOD:
                return 'Increase siege damage by ' + amount + unit;
            case PassiveAuraType.AZTEC_CROCODILE_DAMAGE_MOD:
                return 'Increase aztec crocodile damage by ' + amount + unit;
            case PassiveAuraType.TOTAL_DAMAGE_MOD:
                return 'Increase damage of all units by ' + amount + unit;
            case PassiveAuraType.LIGHT_INFANTRY_CRITICAL_HIT_CHANCE_MOD:
                return 'Increase infantry critical hit chance by ' + amount + unit;
            case PassiveAuraType.RANGED_CRITICAL_HIT_CHANCE_MOD:
                return 'Increase ranged critical hit chance by ' + amount + unit;
            case PassiveAuraType.HEAVY_INFANTRY_CRITICAL_HIT_CHANCE_MOD:
                return 'Increase heavy infantry critical hit chance by ' + amount + unit;
            case PassiveAuraType.CAVALRY_HIT_RATE_MOD:
                return 'Increase cavalry hit rate by ' + amount + unit;
            case PassiveAuraType.CAVALRY_MOVEMENT_SPEED_MOD:
                return 'Increase cavalry movement speed by ' + amount + unit;
            case PassiveAuraType.RANGED_CRITICAL_HIT_DAMAGE_MOD:
                return 'Increase ranged critical hit damage by ' + amount + unit;
            case PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER:
                return 'Add ' + amount + ' extra worker' + (amount > 1 ? 's' : '');
            case PassiveAuraType.GRANTS_TRADE_WORKER:
                return 'Add ' + amount + ' dock worker' + (amount > 1 ? 's' : '');
            case PassiveAuraType.GRANTS_ARABIA_WORKER:
                return 'Add ' + amount + ' arabia worker' + (amount > 1 ? 's' : '');
            case PassiveAuraType.MYSTERY_CHEST:
                return 'Produce a mystery chest.';
            case PassiveAuraType.TREASURE_HUNT_ATTEMPTS_CAP:
                return 'Increase Treasure Hunt attempt cap by ' + amount;
            case PassiveAuraType.RESEARCH_POINT_GENERATION_CAP:
                return 'Increase research point generation cap by ' + amount;
            case PassiveAuraType.EXTRA_COMMANDER_SLOT:
                return 'Grant extra commander slot';
            case PassiveAuraType.GOLD_PRODUCTION_MOD:
                return 'Increase gold production by ' + amount + unit;
            case PassiveAuraType.FOOD_PRODUCTION_MOD:
                return 'Increase food production by ' + amount + unit;
            case PassiveAuraType.CAPITAL_CITY_GOODS_PRODUCTION_MOD:
                return 'Increase capital city goods production by ' + amount + unit;
            case PassiveAuraType.TRADE_OFFER_MOD:
                return 'Increase goods received from trade offers by ' + amount + unit;
            case PassiveAuraType.GEARS_FROM_WONDER_CONTRIBUTION_MOD:
                return 'Increase gears from wonder contribution by ' + amount + unit;
            case PassiveAuraType.VIKINGS_TAVERN_PRODUCTION_MOD:
                return 'Increase all productions from Tavern in Viking Kingdom by ' + amount + unit;
            case PassiveAuraType.ARABIA_GOODS_PRODUCTION_MOD:
                return 'Increase all productions in Arabia by ' + amount + unit;
            case PassiveAuraType.ARABIAN_BAZAAR_OFFERS_MOD:
                return 'Increase bazaar offers when using Arabian bazaar by ' + amount + unit;
            case PassiveAuraType.EGYPT_PRODUCTION_MOD:
                return 'Increase all productions in Egypt by ' + amount + unit;
            case PassiveAuraType.CHINA_PRODUCTION_MOD:
                return 'Increase all productions in China by ' + amount + unit;
            case PassiveAuraType.MAYA_PRODUCTION_MOD:
                return 'Increase all productions in Mayan Empire by ' + amount + unit;
        }
        throw new Error('Unknown passive aura type: ' + this.__type);
    }
}
export default PassiveAura;
